<template>
  <div :class="imageClass">
    <div 
      :class="imageClass"
    >
      <!-- Placeholder -->
      <div
        v-show="status === 'error' || status === 'null' || status === 'loading' "
        style="background: #efefef"
        class="flex md:flex items-center content-center justify-center"
        :class="mergedPlaceholderClasses"
      >
        <ion-skeleton-text
          v-if="status === 'loading'"
          animated
        />

        <div 
          v-if="status === 'error'"
        >
          -
        </div>

        <div
          v-if="status === 'null'"
        >
          -
        </div>
      </div>
    
      <img
        v-if="status === 'loaded' || status === 'loading'"
        v-show="status === 'loaded' "
        :class="mergedClasses"
        :style="setToMax ? 'height: 100%; width: 100%' : ''"
        :src="src + (reloadNr ? `?reload=${reloadNr}` : '')"
        @load="loaded"
        @error="error"
      >
    </div>
  </div>
</template>

<script>
import { useStore } from "@/composables/useTypedStore";
import { IonSkeletonText } from "@ionic/vue";
import { computed, ref, watch } from "vue";

export default {
  name: "AImage",
  components: {
    IonSkeletonText,
  },
  props: {
    imageClass: {
      type: String,
      default: 'w-full h-auto'
    },
    src: {
      type: String,
      default: ''
    },
    setToMax: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const status = ref('loading');

    watch(() => props.src, (newVal) => {

      if (!props.src) {
        status.value = 'null';
      } else {
        status.value = 'loading';
      }
    })

    const reloadNr = ref(0);

    const mergedClasses = computed(() => {
      let classes = props.imageClass;
      if (status.value === 'loaded') {
        classes += " "
      } else {
        classes += " invisible"
      }

      return classes;
    })

    const mergedPlaceholderClasses = computed(() => {
      let classes = props.imageClass;
      if (status.value === 'loaded') {
        classes += " hidden"
      } else {
        classes += " "
      }

      return classes;
    })

    const loaded = () => {
      status.value = 'loaded';
    }

    const error = () => {
      status.value = 'error';
    }

    const store = useStore();
    const isOffline = computed(() => {
      return store.getters["app/isOffline"];
    });

    watch(isOffline, (newVal, oldVal) => {
      if (newVal !== oldVal && status.value !== 'loaded') {
        status.value = 'loading';
        //reloadNr.value ++; // TODO: caused a bug with the image not loading when being in offline mode, not sure what the purpose was of this
      }
    })


    return {
      loaded,
      error,
      mergedClasses,
      mergedPlaceholderClasses,
      reloadNr,
      status,
    }
  }
}
</script>

<style scoped>

.h-200 {
  height: 200px;
}
.w-300 {
  width: 300px;
}

</style>